export default "__VITE_ASSET__DpwPRK1j__"